export default __webpack_public_path__ + "static/ablr-badge-2-4eb06fc6369dfdba71cb1b6bdf066d4e.webp";